<div style="width:100%">
  <main>
    <article #fs fullscreen-able [class.is-active]="isActive" style="background-color: white;">
      <icon-chart [headerConfig]="item?.config?.widget_header_configuration" [iconList]="iconList" [data]="data"
        [pageKey]="pageKey" [chartName]="divId" [config]="pixelMapContainer" [fullscreen]="isFullscreen" [expand]="fs"
        [item]="item" [paginationPageSize]="paginationPageSize" [maxValue]=1000
        [settings]="{ isLockedToVisible, showPatientIDs, useAnalyticalMode, extendBlocks }"
        (onPageSizeChange)="onPageSizeChanged($event)" (typeToSearch)="searchPixelMap($event)"
        (serverSideSearchEmits)="serverSideSearchEmits($event)" [pixelMapRef]="this">
      </icon-chart>
      <div>
        <loading *ngIf="isLoading"> </loading>
      </div>

      <!-- <div style="display:flex">
        <button (click)="toggleVisibleDataLock()">
          <span *ngIf="isLockedToVisible">🔓 Unlock View</span>
          <span *ngIf="!isLockedToVisible">🔒 Lock to Visible</span>
        </button>
        <button (click)="togglePatientIDs()" style="margin-left: 10px;">
          <span *ngIf="showPatientIDs">Hide Patient IDs</span>
          <span *ngIf="!showPatientIDs">Show Patient IDs</span>
        </button>
      </div> -->

      <span class="highlight-info" *ngIf="highlightedNodesCount > 0">
        <strong>Highlighted Nodes: {{ highlightedNodesCount }}</strong>
      </span>



      <!-- Adds a line spacer -->
      <!-- <div class="mb-3 mt-2"><hr></div> -->
      <button class="nav-arrow-button" (click)="goToPatientList($event)" title="Go to Patient List" style="position: absolute; right: 10px; top: 10px; z-index: 100; cursor: pointer; background: white; border: 1px solid #ccc; border-radius: 4px; padding: 4px;">
            <!-- Simple List Icon or Arrow -->
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#4a90e2">
              <path d="M0 0h24v24H0V0z" fill="none" />
              <!-- List Icon -->
              <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" />
            </svg>
      </button>
      <!-- <ng-template #hideLinkCustomTooltip>
        <app-pipeline-tooltip-link [item]="item" [SelectedNavigation]="false" [popupHeading]="popupHeading" [toolTipData]="toolTipData" (hideLinkTooltip)="tooltipLinkHide()" [sortBySelectedData]="this.sortBySelectedData" [patientReasonCode]="patientReasonCode" [isPendingAndActive]="isPendingAndActive"></app-pipeline-tooltip-link>
      </ng-template> -->


      <div class="legend-container">
        <div class="legend-statuses">
          <div *ngFor="let item of legendItems" class="legend-item">
            <span class="legend-dot" [style.background-color]="item.color"></span>
            <span class="legend-label">{{ item.code }}: <strong>{{ item.totalPoints }}</strong></span>
            <span class="legend-value">👤{{ item.uniquePatients }}</span>
          </div>
        </div>

        <hr class="legend-divider">

        <div class="legend-summary">
          <div class="summary-stats">
            <div class="summary-item">Highlighted</div>
            <div class="summary-item">Statuses: <strong>{{ totalSelectedStatuses }}</strong></div>
            <div class="summary-item">Total Points: <strong>{{ totalPoints }}</strong></div>
            <div class="summary-item">👤 Unique Patients: <strong>{{ totalUniquePatients }}</strong></div>
            <div class="summary-item">Total Patients: <strong>{{ totalRecords }}</strong></div>
          </div>

          <div class="legend-toggle">
            <span>Detailed Legend</span>
            <div class="toggle-switch">
              <div class="toggle-handle"></div>
            </div>
          </div>
        </div>
      </div>


      <!-- chart container -->
      <div #pixelMapContainer style="z-index: 1;" [style.display]="(noData || currentView === 'table') ? 'none' : ''"
        class="scrollcss chart-container"
        [ngStyle]="{ 'height':type=='chart'? '300px':( isFullscreen ? 'calc(100dvh - 60px)': 'auto') ,'overflow-y': 'auto'}">
      </div>

      <!-- Table View Grid -->
      <div *ngIf="currentView === 'table' && !noData" style="width: 100%;" class="chart-container"
        [ngStyle]="{ 'height':type=='chart'? '300px':( isFullscreen ? 'calc(100dvh - 60px)': 'auto') ,'overflow-y': 'auto'}">
        <pivot-grid [data]="rowData" [columnDef]="columnDefs" [item]="item" [pivot]="false" [pagination]="false"
          [isFullscreen]="isFullscreen">
        </pivot-grid>
      </div>
      <div style="height: 500px; width: auto; " *ngIf="noData">
        <span class="bg-text">{{ error_name ? error_name : 'There is no data for this time period' }}</span>
      </div>

      <!-- my tooltip -->
      <div id="d3WordCloudTooltip" style="z-index: 23;">
        <div class="container chart_tooltip" style="min-height: 50px; height: auto;" *ngIf="tooltipVisible">
          <div class="row chart_tooltip_header">
            <div class="col-12 d-flex flex-column">
              <div class="chart_tooltip_header_heading mt-1 mb-1">
                {{tooltipData.STATUS_DATE}}
              </div>
            </div>
          </div>

          <div class="mt-1 mb-5 pb-1 chart_tooltip_body'">
            <div class="d-flex m-auto align-items-center pl-0">
              <div class="chart_tooltip_body_data ml-2">
                <div>
                  <p class="mb-0">Patient ID:</p>
                  <p class="tooltipValue mb-1">{{tooltipData.LH_PATIENT_ID}}</p>
                </div>
                <div>
                  <p class="mb-0">Source:</p>
                  <p class="tooltipValue mb-1">{{tooltipData.SP_DESCRIPTION}}</p>
                </div>
                <div>
                  <p class="mb-0">Current Referral status:</p>
                  <p class="tooltipValue mb-1">{{tooltipData.CURRENT_REFERRAL_STATUS}}</p>
                </div>
                <div>
                  <p class="mb-0">Status</p>
                  <p class="tooltipValue mb-1">{{tooltipData.STATUS_GROUP}}</p>
                </div>
                <div>
                  <p class="mb-0">Sub Status</p>
                  <p class="tooltipValue mb-1">{{tooltipData.STATUS_SUB_GROUP}}</p>
                </div>
                <div>
                  <p class="mb-0">Status Code</p>
                  <p class="tooltipValue mb-1">{{tooltipData.STATUS_REASON_CODE}}</p>
                </div>
                <div>
                  <p class="mb-0">Description</p>
                  <p class="tooltipValue mb-1">{{tooltipData.STATUS_REASON_CODE_DESC}}</p>
                </div>
                <div>
                  <p class="mb-0">Patient Initiation Date</p>
                  <p class="tooltipValue mb-1">{{tooltipData.PATIENT_INITIATED_DATE}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </article>
  </main>
</div>

<div class="info-group">
  <div class="pagination-controls">
    <button class="pagination-btn" [disabled]="currentPage === 0">
      <span class="material-icons">first_page</span>
    </button>
    <button class="pagination-btn" (click)="previousPage()" [disabled]="currentPage === 0">
      <span class="material-icons">chevron_left</span>
    </button>

    <span class="page-info">
      <strong>{{ currentPage + 1 }}</strong>/{{ totalPages }}
    </span>

    <button class="pagination-btn" (click)="nextPage()" [disabled]="currentPage >= totalPages - 1">
      <span class="material-icons">chevron_right</span>
    </button>
    <button class="pagination-btn" [disabled]="currentPage >= totalPages - 1">
      <span class="material-icons">last_page</span>
    </button>
  </div>
</div>